
import { Component, Renderer2 } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute, NavigationCancel, NavigationEnd, NavigationError, NavigationStart, Router } from '@angular/router';
import { RequestService } from '@core';
import { LanguagesService } from '@shared/services/languages.service';
import { UtilsService } from '@shared/services/utils.service';
import { BsModalService } from 'ngx-bootstrap/modal';
import { CommonService } from './service/common.service';



@Component({
  selector: 'app-root',
  templateUrl: './app.component.html'
})
export class AppComponent {

  allowedPaths = [
    'cms',
    'notFound'
  ]

  constructor(private utils: UtilsService, private languagesService: LanguagesService,
    private router: Router,
    private modalsService: BsModalService, private title: Title, public commonService: CommonService,
    public requestService: RequestService, private route: ActivatedRoute,private renderer: Renderer2) {
    this.languagesService.initLanguage('it');
    this.router.events.subscribe(event => {
      if (event instanceof NavigationStart) {
        this.call(event.url);
      }
    });


    this.router.events.subscribe((event) => {
      if (event instanceof NavigationStart) {
        // this.utils.inLoading(true);
        this.closeAllModals();

      } else if (event instanceof NavigationEnd ||
        event instanceof NavigationError ||
        event instanceof NavigationCancel) {

        // this.utils.inLoading(false);
      }
    });
  }

  ngOnInit(): void {
  }

  private closeAllModals() {
    for (let i = 1; i <= this.modalsService.getModalsCount(); i++) {
      this.modalsService.hide(i);
    }
    document.getElementsByTagName('body')[0].classList.remove('modal-open');
  }

  public call(pathManual: string) {
    this.utils.inLoading(true);
    const actualPath = pathManual.substring(1);
    if (!this.isAllowedPath(actualPath)) {
      if (actualPath == undefined || actualPath == null || actualPath == "") {
        this.utils.inLoading(false);
        return this.router.navigate(['/notFound']);
      }
      this.commonService.getPage(actualPath).toPromise().then((response) => {
        let stats = response.features[0] ? response.features[0].attributes : null;
        if (stats == null) {
          return this.router.navigate(['/notFound']);
        }
        this.commonService.pages = stats;
        this.commonService.pages.description = this.commonService.pages.description.replace(/\$/gi, '\n');
        this.commonService.pages.links = JSON.parse(this.commonService.pages.links);

        this.commonService.pages.links = this.commonService.pages.links.map(item => ({
          ...item,
          label: item.label.replace('-facoltativo', '').trim()
        }));
        this.creaAccedi();
        const titolo_header = this.commonService.pages.links.filter(x => x.label.toLowerCase() == 'titolo_header')[0]?.description;
        const titolo_descrizione = this.commonService.pages.links.filter(x => x.label.toLowerCase() == 'titolo_descrizione')[0]?.description;

        // filtro le voci del footer escludendo il tasto accedi
        this.commonService.pages.links = this.commonService.pages.links.filter(x => {
          return x.label.toLowerCase() != 'accedi' && x.label.toLowerCase() != 'titolo_header' && x.label.toLowerCase() != 'titolo_descrizione';
        });

        this.commonService.pages.titolo_header = titolo_header ? titolo_header : this.commonService.pages.title;
        this.commonService.pages.titolo_descrizione = titolo_descrizione ? titolo_descrizione : '';
        this.title.setTitle(this.commonService.pages.title);
        this.getFooter([...this.commonService.pages.links]);
        this.commonService.getAttachments(this.commonService.pages.objectid).toPromise().then((response) => {
          this.commonService.pages.logo = [];
          response.attachmentInfos = response.attachmentInfos.sort((a, b) => Number.parseInt(a.name.substring(a.name.indexOf('.') - 1, a.name.indexOf('.'))) - Number.parseInt(b.name.substring(b.name.indexOf('.') - 1, b.name.indexOf('.'))));
          response.attachmentInfos.forEach(img => {
            if (img.name.includes('favicon')) {
              this.setFavicon(this.commonService.urlAttachmentsDetail + this.commonService.pages.objectid + '/' + img.attachmentid);
            } else if (img.name.includes('background')) {
              this.commonService.pages.immagineBackgroundUrl = this.commonService.urlAttachmentsDetail + this.commonService.pages.objectid + '/' + img.attachmentid;
            } else if (img.name.includes('logo_regione_header')) {
              this.commonService.pages.logoRegioneHeader = this.commonService.urlAttachmentsDetail + this.commonService.pages.objectid + '/' + img.attachmentid;;
            } else if (img.name.includes('logo_header_destra')) {
              this.commonService.pages.logo_header_destra = this.commonService.urlAttachmentsDetail + this.commonService.pages.objectid + '/' + img.attachmentid;;
            } else if (img.name.startsWith('logo_body')) {
              this.commonService.pages.logo.push({ url: this.commonService.urlAttachmentsDetail + this.commonService.pages.objectid + '/' + img.attachmentid });
            }
          });
        }
        )
        return stats;
      });
    }

    this.utils.inLoading(false);
  }

  setFavicon(url: string) {
    let link: HTMLLinkElement =
      document.querySelector("link[rel*='icon']") || this.renderer.createElement('link');

    link.type = 'image/x-icon';
    link.rel = 'shortcut icon';
    link.href = url;

    this.renderer.appendChild(document.head, link);
  }

  private creaAccedi() {
    let accedi = "";
    this.commonService.pages.links.forEach(elem => {
      if (elem.label.toLowerCase() === 'accedi') {
        accedi = elem.hyperLink;
      }
    });
    this.commonService.pages.accedi = this.commonService.pages.apps ? (accedi + '?filter=' + this.commonService.pages.apps) : accedi;
  }

  private getFooter(temp: any[]) {
    if (temp !== null && temp !== undefined) {
      this.commonService.pages.sezione1 = temp.splice(0, 3);
      this.commonService.pages.sezione2 = temp.splice(0, 3);
      this.commonService.pages.sezione3 = temp.splice(0, 3);
      this.commonService.pages.sezione4 = temp.splice(0, 3);
    }
  }

  isAllowedPath(string) {
    let res = false;
    this.allowedPaths.forEach(element => {
      if (string.includes(element)) {
        res = true;
      }
    });
    return res;
  }
}

